import React from 'react';
import { T, TolgeeProvider } from '@rakutenfrance/tolgee-provider';
import { Label } from '../Label';
import Box from '@mui/material/Box';
import { staticData } from '../../../translate/tolgee';
export const WarrantyLabel = ({ warrantyLength }) => (React.createElement(TolgeeProvider, { ns: ['mui'], staticData: staticData },
    React.createElement(Label, { icon: "RakutenSymbol", backgroundColor: "green100", textColor: "green800", fontWeight: 600, fontSize: "12px", letterSpacing: "0px", lineHeight: "16px", padding: "small", iconStyle: { width: '16px', height: '16px', padding: '2px 0px 2px 2px' }, textTransform: "none" },
        React.createElement(T, { ns: "mui", keyName: "shipping_badge_warranty" }, "Garantie"),
        "\u00A0",
        React.createElement(Box, { component: "span", sx: { fontWeight: 600 } },
            warrantyLength,
            "\u00A0",
            warrantyLength > 1 ? (React.createElement(T, { ns: "mui", keyName: "shipping_badge_years" }, "ans")) : (React.createElement(T, { ns: "mui", keyName: "shipping_badge_year" }, "an"))))));
